export default "__VITE_ASSET__26e161b2__"